import { useMove } from '@/modules/move';
import React from 'react';

import { useHistoryParams } from '@/navigation';

import { Information, Report } from '../../components';

const Details: React.FC = () => {
  const { moveId } = useHistoryParams();
  const { isLoading, move, setMove, transformedSheets, observationSheets, attachments } =
    useMove(moveId);

  return (
    <Information
      isLoading={isLoading}
      move={move}
      setMove={setMove}
      transformedSheets={transformedSheets}
      observationSheets={observationSheets}
      attachments={attachments}
    >
      <Report move={move} loading={isLoading} />
    </Information>
  );
};

export default Details;
